import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";


const PageTitlesBig = ({icono, texto, subtexto, retorno}) => {
    const navigate = useNavigate();
    return (
        <>

      <div class="row" style={{marginTop:"20px"}}>
        <div class="col-2 smallTitle">
        <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate(retorno)}}/>
        </div>
        <div class="col-1 smallTitlePri">
        <img src={icono}  width="45px"/>
        </div>
       <div class="col-7 bigTitleSecGeneric">
            {texto}
            </div>
            </div>
            <div class="row">
                {subtexto?
                <div class="col bigSubtitle">
                    {subtexto}
                </div>:
                ""
                }
            </div>
        </>

    );
    }
export default PageTitlesBig;